import Vue from '@/index.js'

import page from '@/mixins/page'

import sectionFavorites from '@/components/sections/section-favorites'

export default new Vue({
  el: '#app',
  components: {
    sectionFavorites
  },
  mixins: [page]
})
